var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76439 6.63511C8.07687 6.94758 8.07687 7.45379 7.76439 7.76627C7.60941 7.92251 7.40442 8 7.19944 8C6.99445 8 6.78997 7.92188 6.63398 7.76564L3.99969 5.13272L1.36564 7.76502C1.20941 7.92251 1.00467 8 0.799938 8C0.595204 8 0.39072 7.92251 0.234357 7.76502C-0.0781189 7.45254 -0.0781189 6.94633 0.234357 6.63386L2.86915 3.99906L0.234357 1.36552C-0.0781189 1.05304 -0.0781189 0.546832 0.234357 0.234357C0.546832 -0.0781189 1.05304 -0.0781189 1.36552 0.234357L3.99969 2.8704L6.63448 0.235607C6.94696 -0.0768689 7.45317 -0.0768689 7.76564 0.235607C8.07812 0.548082 8.07812 1.05429 7.76564 1.36677L5.13085 4.00156L7.76439 6.63511Z",
    fill: "#B55F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkIcon);
export default __webpack_public_path__ + "static/media/XmarkIcon.8f9bd7eae3a2da2c682f72013a3fa1d7.svg";
export { ForwardRef as ReactComponent };